import { forwardRef } from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '../../../utils';

export interface CheckboxProps extends CheckboxPrimitive.CheckboxProps {
  label?: string;
}

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  ({ className, label, id, ...props }, ref) => {
    const checkboxId = id || label?.toLowerCase().replace(/\s+/g, '-');
    return (
      <div className="flex items-center gap-2">
        <CheckboxPrimitive.Root
          ref={ref}
          id={checkboxId}
          className={cn(
            'h-5 w-5 shrink-0 rounded border border-border-hover',
            'bg-[var(--field-bg)]',
            'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[color:var(--ring-color)] focus-visible:ring-offset-1 focus-visible:ring-offset-surface',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'data-[state=checked]:bg-[var(--action-primary)] data-[state=checked]:border-[var(--action-primary)]',
            'transition-colors',
            className
          )}
          {...props}
        >
          <CheckboxPrimitive.Indicator className="flex items-center justify-center text-[var(--action-primary-fg)]">
            <Check className="h-4 w-4" />
          </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
        {label && (
          <label
            htmlFor={checkboxId}
            className="text-sm text-text-secondary cursor-pointer"
          >
            {label}
          </label>
        )}
      </div>
    );
  }
);
Checkbox.displayName = 'Checkbox';
